export const nearMissTrackHeadShouldDisplayFunc = `!!(trackHead.metadata?.nearMissesMap && Object.keys(trackHead.metadata?.nearMissesMap).length > 0) ||
!!(dtf.trackHeads && dtf.trackHeads.some(otherTrackHead =>
  Object.entries(otherTrackHead.nearMissesMap).some(([otherID]) => otherID === trackHead.trackNumber.toString())
))`;
